import { HttpClient, HttpErrorResponse, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, tap } from 'rxjs';
// Models
import { User, Vehicle, Battery, BatteryLogbook, VehicleLogbook, PilotLogbookBackend, TimeZone, MultipleApiResponse } from '@mocca-technologies/model';
import {
    BATTERY_LOGBOOKS,
    ALL_BATTERIES,
    PILOT_LOGBOOK,
    BATTERY_CHARGING_REGISTER,
    UPDATE_LOG_ACTIVITY,
    VEHICLE_LOGBOOKS,
} from 'src/app/utils/routing/routes.model';

import { TimeFilter } from 'src/app/pages/logbooks/components/logbooks-time-filter/logbooks-time-filter.component';

import { environment } from 'src/environments/environment';

@Injectable()

export class LogbookService {

    constructor(private http: HttpClient) {}

    getPilotLog(timeFilter: TimeFilter, user: User){
        const httpParams = new HttpParams()
                .set('selectedFilter', timeFilter?.selectedFilter)
                .set('selectedNumberOfMonths', timeFilter?.selectedNumberOfMonths?.toString())
                .set('selectedNumberOfYears', timeFilter?.selectedNumberOfYears?.toString())
                .set('selectedYear', timeFilter?.selectedYear?.toString())
                .set('userId', user?.uniqueId);

        return this.http.get<MultipleApiResponse>(PILOT_LOGBOOK, {
            params: httpParams,
            observe: 'response',
            withCredentials: true
        }).pipe(
          tap((res: HttpResponse<MultipleApiResponse>) => {
              return(res);
          }),
          catchError((error: HttpErrorResponse) => {
              throw error;
          })
        );
    }

    getVehicleLog(timeFilter: TimeFilter,vehicle: Vehicle){
        const httpParams = new HttpParams()
                .set('selectedFilter', timeFilter?.selectedFilter)
                .set('selectedNumberOfMonths', timeFilter?.selectedNumberOfMonths?.toString())
                .set('selectedNumberOfYears', timeFilter?.selectedNumberOfYears?.toString())
                .set('selectedYear', timeFilter?.selectedYear?.toString())
                .set('vehicleId', vehicle.uniqueId)
                .set('organizationId', vehicle.organizationUuid);

        return this.http.get<MultipleApiResponse>(VEHICLE_LOGBOOKS, {
            params: httpParams,
            observe: 'response',
            withCredentials: true
        }).pipe(
            tap((res: HttpResponse<MultipleApiResponse>) => {
                return(res);
            }),
            catchError((error: HttpErrorResponse) => {
                throw error;
            })
        );
    }

    getBatteryLog(timeFilter: TimeFilter, battery: Battery, organizationId: string){

        const httpParams = new HttpParams()
                .set('selectedFilter', timeFilter?.selectedFilter)
                .set('selectedNumberOfMonths', timeFilter?.selectedNumberOfMonths?.toString())
                .set('selectedNumberOfYears', timeFilter?.selectedNumberOfYears?.toString())
                .set('selectedYear', timeFilter?.selectedYear?.toString())
                .set('batterySN', battery?.sn)
                .set('organizationId', organizationId);
        return this.http.get<MultipleApiResponse>(BATTERY_LOGBOOKS, {
            params: httpParams,
            observe: 'response',
            withCredentials: true
        }).pipe(
            tap((res: HttpResponse<MultipleApiResponse>) => {
                return(res);
            }),
            catchError((error: HttpErrorResponse) => {
                throw error;
            })
        );
    }

    getBatteries() {
        return this.http.get<MultipleApiResponse>(ALL_BATTERIES, {
            observe: 'response',
            withCredentials: true
        }).pipe(
            tap((res: HttpResponse<MultipleApiResponse>) => {
                return(res);
            }),
            catchError((error: HttpErrorResponse) => {
                throw error;
            })
        );
    }

    buildLocation(location: TimeZone): string {
        let locationString = '';

        if (location.countrySubdivision3) {
            locationString += location.countrySubdivision3 + ', ';
        }

        if (location.countrySubdivision2) {
            locationString += location.countrySubdivision2 + ', ';
        }

        if (location.countrySubdivision1) {
            locationString += location.countrySubdivision1 + ', ';
        }

        if (location.countryName) {
            locationString += location.countryName;
        }

        if (locationString.endsWith(', ')) {
            locationString = locationString.slice(0, -2);
        }

        if (locationString === '') {
            locationString = 'No location provided';
        }

        return locationString;
    }

    batteryRegister(username: string, password: string, batterySN: string, date: Date) {
        const body = {
            batterySN: batterySN,
            date: date.toISOString(),
            username: username,
            password: password,
        };

        return this.http.post<MultipleApiResponse>(BATTERY_CHARGING_REGISTER, body, {
            observe: 'response',
            withCredentials: true
        }).pipe(
            tap((res: HttpResponse<MultipleApiResponse>) => {
                return(res);
            }),
            catchError((error: HttpErrorResponse) => {
                throw error;
            })
        );
    }

    updatePilotLogActivity(activity: string, flightOperationUuid: string) {
        const httpParams = new HttpParams().set('flightOperationUuid', flightOperationUuid).set('operationNature', activity);

        return this.http.put<MultipleApiResponse>(UPDATE_LOG_ACTIVITY, {}, {
            observe: 'response',
            withCredentials: true,
            params: httpParams
        }).pipe(
            tap((res: HttpResponse<MultipleApiResponse>) => {
                return(res);
            }),
            catchError((error: HttpErrorResponse) => {
                throw error;
            })
        );
    }

    /**
     * This method is used to get the capacity color of a battery depending on the capacity percentage
     * @param capacity
     * @returns
     */
    getCapacityColor(capacity: number | undefined): string {

        if (capacity === undefined || capacity === null) {
            return 'secondary';
        }

        if (capacity < 25) {
            return 'danger';
        } else if (capacity < 75) {
            return 'warning';
        } else {
            return 'success';
        }
    }


}
